var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJeffreyjump1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490.44 430.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-3 {\n        stroke: #474748;\n      }\n\n      .cls-8 {\n        fill: #b7b7b7;\n      }\n\n      .cls-8, .cls-9 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #6d6d6d;\n        stroke: #6d6d6d;\n      }\n\n      .cls-9 {\n        fill: #d7d7d7;\n      }\n\n      .cls-3 {\n        fill: #474748;\n      }\n\n      .cls-4 {\n        fill: #b6b6b6;\n        stroke: #b6b6b6;\n      }\n\n      .cls-5 {\n        fill: #878787;\n        stroke: #878787;\n      }\n\n      .cls-6 {\n        fill: #e9e9e9;\n        stroke: #e9e9e9;\n      }\n\n      .cls-7 {\n        fill: #a7a7a7;\n        stroke: #a7a7a7;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Colour_mirror-2",
    "data-name": "Colour mirror-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M316.22,314.48l-9.2,4.3-2.4-3,2.3-24.2-30.8-18.2-30.4,6.1-31.4-6.1-30.8,18.2,2.3,24.2-2.4,3-9.2-4.3-5.2,5.1v9.2l14.5,23,5.2,3.6,6.9-1.5s11.1,26.6,20.2,34.5c9.2,7.9,15.7,12.6,15.7,12.6l13.8,1.3h1l12.8-1.3s6.5-4.7,15.7-12.6,20.2-34.5,20.2-34.5l6.9,1.5,5.2-3.6,14.5-23v-9.2l-5.2-5.1h-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.42,326.98s-.8,1.1,2,5.7c2,3.3,3.9,8.5,6.2,10,0,0-.7-11.7-2.1-13.5s-6.2-2.2-6.2-2.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M204.32,318.38l-5.3,2.5s.9,4.5,4.1,5.7c3.2,1.1,10.3,1.3,10.3,1.3,0,0,11.4-.2,12.6-.9,2.6-1.7,2.6-7.9,2.6-7.9l-13.8-2.4-10.5,1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "213.82 316.68 212.02 322.28 215.22 326.98 224.22 326.08 225.42 320.68 221.82 317.48 213.82 316.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.22,352.48s-5-1.8-6.6-1.3c-3.2,1-4,2.7-4,2.7,0,0,7.9,2.9,10.6,2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "220.32 370.28 231.62 380.28 245.22 382.38 245.22 367.88 220.32 370.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "230.72 379.28 247.22 374.58 246.92 383.28 230.72 379.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "229.92 369.28 245.72 372.18 245.22 366.78 229.92 369.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.02,391.58v32.7l37.3,5.1-4.5-25.7s-15.7,1.5-20.2-2.2-12.6-9.8-12.6-9.8h0v-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "38.82 418.68 58.02 316.38 54.92 283.98 48.42 244.38 45.32 229.48 46.92 214.48 54.42 219.18 54.92 237.48 65.72 255.98 70.42 258.68 71.82 232.98 79.02 205.08 84.42 202.58 88.12 210.88 87.22 231.78 88.12 252.98 91.72 252.48 92.32 226.38 95.12 207.38 96.52 200.68 101.62 200.68 105.12 206.98 105.12 226.48 106.92 238.18 109.52 226.88 120.32 204.58 124.22 205.28 125.52 213.38 121.12 231.78 120.52 270.18 125.32 276.58 139.12 268.18 149.62 259.88 156.12 260.68 160.32 267.48 147.12 277.78 143.62 283.98 122.82 306.08 101.42 316.68 97.52 324.88 97.82 375.68 99.52 411.68 96.22 420.08 38.82 418.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M77.82,278.18s10.1,3.7,14.8,12.4c0,0,11.7-13.2,13.7-13.9,0,0,.4-1.8-4.1-1.2s-6.6,2.6-9.5,2.4-7.9-2.7-10.8-2.5-4.1,2.9-4.1,2.9h0v-.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M315.12,326.98s.8,1.1-2,5.7c-2,3.3-3.9,8.5-6.2,10,0,0,.7-11.7,2.1-13.5s6.2-2.2,6.2-2.2h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.12,318.38l5.3,2.5s-.9,4.5-4.1,5.7c-3.2,1.1-10.3,1.3-10.3,1.3,0,0-11.4-.2-12.6-.9-2.6-1.7-2.6-7.9-2.6-7.9l13.8-2.4,10.5,1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "276.62 316.68 278.42 322.28 275.32 326.98 266.32 326.08 265.02 320.68 268.62 317.48 276.62 316.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M245.22,352.48s5-1.8,6.6-1.3c3.2,1,4,2.7,4,2.7,0,0-7.9,2.9-10.6,2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "270.22 370.28 258.82 380.28 245.22 382.38 245.22 367.88 270.22 370.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "259.72 379.28 243.32 374.58 243.62 383.28 259.72 379.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "260.52 369.28 244.82 372.18 245.22 366.78 260.52 369.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M274.42,391.58v32.7l-37.3,5.1,4.5-25.7s15.7,1.5,20.2-2.2,12.6-9.8,12.6-9.8h0v-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "451.62 418.68 432.42 316.38 435.52 283.98 442.02 244.38 445.12 229.48 443.52 214.48 436.02 219.18 435.52 237.48 424.72 255.98 420.12 258.68 418.62 232.98 411.42 205.08 406.02 202.58 402.32 210.88 403.32 231.78 402.32 252.98 398.72 252.48 398.12 226.38 395.42 207.38 393.92 200.68 388.92 200.68 385.32 206.98 385.32 226.48 383.62 238.18 380.92 226.88 370.12 204.58 366.22 205.28 364.92 213.38 369.32 231.78 370.02 270.18 365.22 276.58 351.32 268.18 340.82 259.88 334.32 260.68 330.22 267.48 343.32 277.78 346.82 283.98 367.62 306.08 389.12 316.68 393.02 324.88 392.62 375.68 390.92 411.68 394.22 420.08 451.62 418.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M412.62,278.18s-10.1,3.7-14.8,12.4c0,0-11.7-13.2-13.7-13.9,0,0-.4-1.8,4.1-1.2s6.6,2.6,9.5,2.4,7.9-2.7,10.8-2.5,4.1,2.9,4.1,2.9h0v-.1h0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Colour_Normal-2",
    "data-name": "Colour Normal-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M259.72,309.88s-7.1,10.8-7.8,13,1.3,28.3,1.3,28.3l1.1,3.4s9.2-2.6,9.2-6.2-5.9-25.4-5.9-25.4c0,0,6.2-9.6,14.4-7.1,3.7,1.1-3.1-8.7-3.1-8.7l-9.2,2.8h0v-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M288.02,291.48s-1.5,12.5-3.4,15.5-2.9,10.1-2.9,10.1l11.3,3.2s-3.5,10.5-5.1,12-4.7,2.9-5.6,6.6-2.9,25.3-5.3,31.7-13.8,27.6-13.8,27.6c0,0,20.4-22.5,23.3-28.1s15.1-33.8,15.2-40.1,2.5-22.2,2.5-22.2l-16.1-16.4-.1.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "179.62 269.38 171.52 289.78 171.92 303.58 174.22 313.28 185.32 316.48 189.52 301.78 194.82 297.68 189.42 295.48 197.22 288.58 208.92 284.58 218.22 286.28 214.22 277.38 222.12 279.48 229.92 281.98 240.32 281.68 245.22 280.38 251.72 279.28 261.82 281.38 271.02 284.58 273.42 287.38 282.02 289.68 293.02 292.98 295.02 300.08 299.72 302.48 302.32 308.88 304.82 320.18 313.72 314.28 319.62 312.98 324.22 295.38 320.52 290.68 317.02 274.98 316.22 260.48 311.92 255.98 308.72 249.88 299.82 243.38 290.52 233.28 287.52 222.58 284.42 212.78 272.02 221.98 261.82 222.18 265.62 213.88 254.12 219.28 242.32 220.08 230.12 225.38 225.22 231.68 225.22 227.18 225.22 219.58 202.32 237.18 197.32 243.88 189.52 253.18 185.52 264.18 179.62 269.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M225.42,237.38s2.7-6.6,12.9-9.2c6.2-1.6,12.3-2.9,18-1.4,0,0-10.4,6.9-9,11.4s6.1,4.7,10.7,4.7c9.7,0,15.9-4.1,15.9-4.1,0,0-6.3,14.9-22.4,16.9-6,.8-22.6,1.9-21.2-4.3,1.8-8,7.6-11.4,4.8-14.1s-9.6.1-9.6.1h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.92,251.98s-5.8,10.7-3.7,15,4.8,9.8,11.8,7.9c7-1.8,5.6-8.8,5.1-11.3s2.8-14.4,3.9-20.9c0,0-5.9,8.8-7.1,14.3-.9,4.3-3.6,6.8-7.4,5.4s-2.6-10.5-2.6-10.5h0v.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M179.12,281.18c3.5-1.9,6,3.4,7,3.7s5.4,1.6,5.1,2.7-4.4,1.6-6.1,3.3-1.1,3-1.9,4.1-6.7.9-7.7-2.8.6-9.4,3.5-11h.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M263.12,263.68c-3-1,11.6-4.6,15.5-11,3.1-5,5.2-12.1,6.8-12.9,1.2-.7,2.2,11.6-3.3,16.5-7.4,6.5-14.2,9-19,7.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M278.02,270.68c-.9.2-1.4-.9-.8-1.5,4.3-4.1,7.6-5.9,14.1-10,1.4-.9,4-7.8,5.6-7.2s3.1,5.7,4.5,12.2c1.4,6.6-4.2,13-11.8,15.4,0,0,2.6-3.1.2-7-1.5-2.5-8.5-2.6-11.8-2h0v.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M306.52,282.28c1.9-1.9,4.1-10.4,5.4-8.9s2.3,11-2.2,12.4-13.4,5.2-13.5,4.1,8.7-6,10.3-7.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M437.82,216.58c2.1,1.8,4.5,12.4,3.5,16.1s-6.8,21.7-7,25.2-9.4,37.4-9.4,48.8-15.9,11.7-15.9,11.7c0,0,14.9.7,15,4.2s15.2,80.3,14,91.7,13.4,0,13.4,0c0,0-7.7-48.4-11.1-60s-8.1-39.7-8.1-39.7l4.9-48.4,7.3-31.8-1.7-18.8-4.9,1.1h0v-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M371.42,206.28s6.3,17.9,6.3,22.4,2.6,24.1,2.6,24.1l1.5-8.8-2.6-17.7-7.9-20h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M392.82,252.78c.7-4.5,3.8-21.9,1.7-31s-1.7-20.5-1.7-20.5l3.9,24.2v27.2h-3.9v.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M410.02,202.68s-.5,18.8,3.7,26.9l1.1,29.6h5.3l-2.4-28.2-7.7-28.2h0v-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.32,202.58c1.5,7.4-1.8,28.6-1.8,28.6,0,0,.4,20.3,2.2,21.6s4.6.7,4.6.7l-3.4-25.4,1.2-23-2.8-2.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M99.52,200.08c2.4,5.3,1.7,23.2,1.7,26.3s1.3,25.6,3.3,26.4,4.1.3,4.1.3l-4.6-26.4.8-20.4-5.4-6.2h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.52,204.48c1.7,4.1,1.7,13.3-2.4,23.6,0,0-3.1,18.7-1.8,25.5s-.3,15.6-.3,15.6l4.9,3.5-.9-42.9,5.3-22.9-4.9-2.4h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.22,259.68c4.2,3,3.7,5.6-3.2,13s-18.1,21.5-23,24.1-18.6,12.9-24.5,15.5-25.3,4.4-25.3,4.4c0,0,15.8-3.3,18.9,2.4,1.9,3.5-5.9,39-3.9,56.6,1.9,17.6,0,39.6,0,39.6l10-1-1.8-42.1v-51.7l8.3-8.2,17.6-7.3,18.8-21,7.9-11.3,9.9-6.4-9.7-6.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50.12,215.38c2.5,8,3,22.8,3,22.8,0,0,6.4,20.3,9.2,20.4,2.8.1,5.8,0,5.8,0-6-1.9-9.3-13.8-13.5-22.8l-1.4-18.9-3.2-1.4h0l.1-.1h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Mirror-2",
    "data-name": "Lines Mirror-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.22,403.58s4,0,11.1-1.6c12.3-2.9,27.2-22.8,34.3-35.4,7.4-13.2,14.9-46.2,14.9-46.2,0,0,6.2-7.6,12-5.6s4.7,12.6,3.7,14.7-11.2,22.8-17.3,26.1c-3.7,2.1-7.4-1.7-7.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.12,325.88s.5-2.1-1.4-2.1-6.6,4.9-7.5,8.8.4,8-1,11.7c-1.1,2.8-2.6,3.1-2.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.52,326.98s-4.9,2.2-11.1,1.8c-2.1-.1-6.4-1.2-9.8-1.2s-6.1.8-6.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M294.12,309.28s-9.2-3-16.2-3.8c-4.2-.5-13.5-.7-14.3-.3s-4.2,3.8-3.2,3.9c1.1.2,12.8-1.6,18.5-1.6,6.7,0,15.2,1.8,15.2,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.92,320.48s-13.7-4.6-18.8-4.4-13.4,4-13.4,4c0,0,2.7-5.3,4.6-6.2s8.5-1.5,8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.62,326.98s-1.8-1.4-2.1-3.3c-.5-3.8,4.1-5.7,5.4-5.9,5.4-.7,10.3,2.7,10.5,5.4s-4.3,5.3-4.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M253.62,354.08s-1.1-.2-2,0-2.1,1.3-2.1,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.22,366.78c12.8-.6,27.2,3.4,27.2,3.4-5.6,3.8-9.3,8-14.6,10.5-5.2,1.4-12.6,1.7-12.6,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.52,368.28s-1.8,3.9-16.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.72,378.88s-5-3.4-14.5-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.92,414.28s-1.1-13.2,0-25.8"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.22,403.58s-4,0-11.1-1.6c-12.3-2.9-27.2-22.8-34.3-35.4-7.4-13.2-14.9-46.2-14.9-46.2,0,0-6.2-7.6-12-5.6s-4.7,12.6-3.7,14.7,11.2,22.8,17.3,26.1c3.7,2.1,7.4-1.7,7.4-1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M174.32,325.88s-.5-2.1,1.4-2.1,6.6,4.9,7.5,8.8c.8,3.9-.4,8,1,11.7,1.1,2.8,2.6,3.1,2.6,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.92,326.98s4.9,2.2,11.1,1.8c2.1-.1,6.4-1.2,9.8-1.2s6.1.8,6.1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M196.42,309.28s9.2-3,16.2-3.8c4.2-.5,13.5-.7,14.3-.3s4.2,3.8,3.2,3.9c-1.1.2-12.8-1.6-18.5-1.6-6.7,0-15.2,1.8-15.2,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M197.62,320.48s13.7-4.6,18.8-4.4,13.4,4,13.4,4c0,0-2.7-5.3-4.6-6.2s-8.5-1.5-8.5-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.82,326.98s1.8-1.4,2.1-3.3c.5-3.8-4.1-5.7-5.4-5.9-5.4-.7-10.3,2.7-10.5,5.4s4.3,5.3,4.3,5.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.82,354.08s1.1-.2,2,0,2.1,1.3,2.1,1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.22,366.78c-12.8-.6-27.2,3.4-27.2,3.4,5.6,3.8,9.3,8,14.6,10.5,5.2,1.4,12.6,1.7,12.6,1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.92,368.28s1.8,3.9,16.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.72,378.88s5-3.4,14.5-3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M215.52,414.28s1.1-13.2,0-25.8"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Normal-2",
    "data-name": "Lines Normal-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.02,320.48s2.2-13.3,3.9-16.2,7.4-6.7,7.4-6.7l-5.7-1.6s1.9-3.8,4.9-5.4,12.5-3.8,12.5-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172.92,314.78c-2.2-3.5-1-8.9-1-8.9-3.3-3.9-2.2-12.5-1.7-17.7,1-10.8,14.8-26.6,14.8-26.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.52,229.08c-12.1,4.2-28.5,23.7-29.5,32.6s1.4,15.4,7.9,19.2c4,2.3,26.6,5.8,26.6,5.8l-5.4-7.2,9.1,2.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M201.52,257.08s2.8-12.3,6.6-19.7,15.1-15.5,17.4-22.2c0,0,.2,4.2-.5,13.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.32,283.18s-10.8-8-12.8-16.7-1.3-18,6.2-28.8,12.5-17.6,25.5-19.1c7.8-.9,9.2,2.2,20.6-7.5,0,0,2.1,7-3.1,11,0,0,7.3-.5,11.8-3.8s10.1-9.7,10.1-9.7c0,0,1.4,20.6-9.4,39.1-9.2,15.8-20.8,11.8-28.1,17.8s-6.2,15.2-6.2,15.2c0,0-3.1,5.3-14.5,2.6h0l-.1-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M285.42,212.98s5.4,11.8,5.4,20.1-.5,18.2-.5,18.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M241.62,281.08s5.3,2.2,9.8.7,18.8-10.8,18.8-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M284.52,279.58s-12.6,6-18.1,5.7-13.1-3.8-13.1-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M290.82,231.18s7.2,8.7,10.7,12.1,12.3,4.7,7.5,22.9c-4.5,16.8-18.8,20.7-30.2,23.4-7.4,1.8-9.9-2.8-9.9-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.42,255.08s4.5,1.2,5.5,4.8,3.4,22.7-2.9,32.5c-5.8,9.1-13.2,11.4-19.8,8.8-1.9-.8-.4-4.6-.5-5.9s-10.2-1-12.1-4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.62,276.58c3.4,1.4,2.4,8.1,3.4,12s4.8,4.6,3.4,11.2-6.8,14.8-6.8,14.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.72,301.98s-1.9,1.2-.1,5.8,3.8,4.5,4.2,11.2,0,10.5,0,10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M228.62,240.58s-7.8,9.9-8.7,16.5c-.9,6.6-3.5,16.6,3.3,23.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Lines_Hands-2",
    "data-name": "Lines Hands-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.12,246.68c0-4.6-1.5-11.9-1.2-14.7.5-5.5-8.9-23.5-10.5-26.1s-4.4-2.4-6.3,1,1.8,14.5,3.7,21.7c1.8,7.2.9,20.5.9,24.2s.5,19.2.5,19.2c0,0-3.8,4.3-4.9,4.5s-12.9-7.9-13.9-8.4-7.2-8.9-13.3-8.8-7.8,8.1-7.8,8.1c9,5.4,14.1,10.6,15.8,14.9s18,21.4,20.5,23.7,14,6.1,14,6.1c0,0,11.9,3.9,11.9,13.4s.9,28.9.5,44.5-4.2,35-1.6,44.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.72,257.68s-2.9-13.4-2-25.7c0,0-6-17.4-6-25.7,1-2.2-5.9-7-9.3-1.2-2.7,4.7.8,19.3.1,24.2s-.2,20.4-2.5,22.9-2.7-1.1-2.7-1.1c0,0-.6-17.7-.1-23s-2.9-17-2.9-23.8-8-3.8-8.9-1.1-3,12.6-1.5,22-3,28-3,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M419.32,259.08s6.2-1.7,7.2-6.2,7.2-14.2,7.9-18.3-.6-18.2,5.1-19.4,4.5,0,4.5,0c0,0,1.5,13.7,1.1,18.3-.4,4.7-5.5,25.2-5.3,28.9,0,0-5.3,23.9-5.7,36-.4,12.1-1.6,17.9-1.6,17.9,0,0,17.9,87.6,19.2,97.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.42,246.68c0-4.6,1.5-11.9,1.2-14.7-.5-5.5,8.9-23.5,10.5-26.1s4.4-2.4,6.3,1-1.8,14.5-3.7,21.7c-1.9,7.2-.8,20.5-.8,24.2s-.5,19.2-.5,19.2c0,0,3.8,4.3,4.9,4.5s12.9-7.9,13.9-8.4,7.2-8.9,13.3-8.8,7.8,8.1,7.8,8.1c-9,5.4-14.1,10.6-15.8,14.9s-18,21.4-20.5,23.7-14,6.1-14,6.1c0,0-11.8,3.9-11.8,13.4s-.9,28.9-.5,44.5,4.2,35,1.6,44.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M69.82,257.68s2.9-13.4,2-25.7c0,0,6-17.4,6-25.7-1-2.2,5.9-7,9.3-1.2,2.7,4.7-.8,19.3-.1,24.2s.2,20.4,2.5,22.9,2.7-1.1,2.7-1.1c0,0,.6-17.7.1-23s2.9-17,2.9-23.8,8-3.8,8.9-1.1,3,12.6,1.5,22,3,28,3,28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.12,259.08s-6.2-1.7-7.2-6.2-7.2-14.2-7.9-18.3.6-18.2-5.1-19.4-4.5,0-4.5,0c0,0-1.5,13.7-1.1,18.3.4,4.7,5.5,25.2,5.3,28.9,0,0,5.3,23.9,5.7,36s1.6,17.9,1.6,17.9c0,0-17.9,87.6-19.2,97.9"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeffreyjump1);
export default __webpack_public_path__ + "static/media/jeffreyjump1.c5ef57ce590d1b05600a828e1f879fde.svg";
export { ForwardRef as ReactComponent };